var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F5F6F8",
    stroke: "#E4E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 19.2998C21.7335 19.2998 18.5255 21.7619 15.9321 24.956C15.438 25.5645 15.438 26.4351 15.9321 27.0437C18.5255 30.2377 21.7335 32.6998 26 32.6998C30.2666 32.6998 33.4746 30.2377 36.068 27.0437C36.5621 26.4351 36.5621 25.5645 36.068 24.956C33.4746 21.7619 30.2666 19.2998 26 19.2998ZM24.2001 25.9998C24.2001 25.0056 25.006 24.1998 26.0001 24.1998C26.9942 24.1998 27.8001 25.0056 27.8001 25.9998C27.8001 26.9939 26.9942 27.7998 26.0001 27.7998C25.006 27.7998 24.2001 26.9939 24.2001 25.9998ZM26.0001 22.7998C24.2328 22.7998 22.8001 24.2324 22.8001 25.9998C22.8001 27.7671 24.2328 29.1998 26.0001 29.1998C27.7674 29.1998 29.2001 27.7671 29.2001 25.9998C29.2001 24.2324 27.7674 22.7998 26.0001 22.7998Z",
    fill: "#898D9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticEyeIcon);
export default __webpack_public_path__ + "static/media/statistic-eye-icon.64bcf2b4bae50fa0c2c9224276353cf4.svg";
export { ForwardRef as ReactComponent };